<script setup lang="ts">
import { Circle } from 'lucide-vue-next'
import { RadioGroupIndicator, RadioGroupItem, type RadioGroupItemProps, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<RadioGroupItemProps & { class?: HTMLAttributes['class']; disabled?: boolean }>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

// eslint-disable-next-line unicorn/prevent-abbreviations
const forwardedProps = useForwardProps(delegatedProperties)
</script>

<template>
  <RadioGroupItem v-bind="forwardedProps" :class="cn('atabix-radiogroup-item', props.class)" :disabled="disabled">
    <RadioGroupIndicator class="">
      <Circle class="size-3 fill-current text-current" />
    </RadioGroupIndicator>
  </RadioGroupItem>
</template>

<style lang="scss">
.atabix-radiogroup-item {
  @apply aspect-square;
  @apply h-4;
  @apply w-4;
  @apply flex items-center justify-center;
  @apply rounded-full;
  @apply border;
  @apply border-button-ghostprimary-text;
  @apply text-button-ghostprimary-text;
  @apply ring-offset-background;
  @apply focus:outline-none;
  @apply focus-visible:ring-2;
  @apply focus-visible:ring-border;
  @apply focus-visible:ring-offset-2;
  @apply disabled:cursor-not-allowed;
  @apply disabled:opacity-50;
}

.atabix-radiogroup-indicator {
  @apply flex;
  @apply items-center;
  @apply justify-center;
}
</style>
